<template>
  <div class="modelTheOld" v-loading="loading">
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="demo-form-inline"
    >
      <el-form-item label="疑似房屋单月用水阈值≥">
        <el-input-number
          v-model="tableParams.ysfwyyysqz"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <span class="spanmargin">吨</span>
        <!-- @change="handleChange" -->
      </el-form-item>
      <el-form-item label="疑似房屋单月用电阈值≥" prop>
        <el-input-number
          v-model="tableParams.yongdian"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <span class="spanmargin">度</span>
      </el-form-item>
      <el-form-item label="疑似房屋单月用气阈值≥" prop>
        <el-input-number
          v-model="tableParams.yongqi"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <span class="spanmargin">立方</span>
      </el-form-item>
      <el-form-item class="bottomBtn">
        <h-button type="primary" @click="uploade">导入</h-button>
        <h-button type="primary" @click="download">模板下载</h-button>
        <input type="file" v-show="false" ref="file" @change="myup" />
      </el-form-item>
      <el-form-item class="bottomBtn">
        <h-button type="primary" @click="baocun">保存</h-button>
        <!-- <h-button type="">取消</h-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import { dictUpdate, getDict } from "@/api/constant.js";
import { ElMessage } from "element-plus";
import { uploadweg, downloadweg } from "@/api/system/region.js";
export default defineComponent({
  name: "modelTheOld",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      loading: false,
      tableParams: {
        ysfwyyysqz: "",
        yongdian: "",
        yongqi: "",
      },
      num: 1,
    });
    const file = ref();
    const refData = toRefs(data);
    const baocun = async () => {
      data.loading = true;
      // 疑似房屋单月用水阈值
      const res = await getDict("house_water_threshold");
      const params = res.dict[0];
      params.value = data.tableParams.ysfwyyysqz;
      await dictUpdate(params);
      // 疑似房屋单月用电阈值
      const yd = await getDict("house_electricity_threshold");
      const ydparams = yd.dict[0];
      ydparams.value = data.tableParams.yongdian;
      await dictUpdate(ydparams);
      // 疑似房屋单月用气阈值
      const yq = await getDict("house_gas_threshold");
      const yqparams = yq.dict[0];
      yqparams.value = data.tableParams.yongqi;
      await dictUpdate(yqparams);
      data.loading = false;
      ElMessage({
        type: "success",
        message: "修改成功",
      });
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      // console.log(file.name);
      var filename = file.name;
      var excelname = filename.substring(filename.lastIndexOf("."));
      console.log(excelname);
      if (excelname != ".xls" && excelname != ".xlsx") {
        alert("请先下载模板后再上传!");
      } else {
        const result = await uploadweg(param);
        if (result.code == 0) {
          ElMessage({
            type: "success",
            message: "上传成功",
          });
        }
        console.log("result", result);
      }
    };

    // 下载模板
    const download = async () => {
      const res = await downloadweg();
      console.log(res);
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      });
      const objUrl = URL.createObjectURL(blob);
      window.location.href = objUrl;
    };
    return {
      ...refData,
      baocun,
      uploade,
      myup,
      file,
      download,
    };
  },
});
</script>
<style lang="scss" scoped>
.modelTheOld {
  .demo-form-inline {
    display: flex;
    flex-direction: column;
  }
  .bottomBtn {
    margin-left: 150px;
  }
}
.spanmargin {
  margin: 0 10px;
}
.bottomBtn {
  span {
    margin-right: 10px;
  }
}
.borderColor {
  color: #5584ff;
  border-bottom: 1px solid;
  margin-left: 10px;
  cursor: pointer;
}
</style>
